// extracted by mini-css-extract-plugin
export default {"success":"textColor_success__jnVI8","default":"textColor_default__ksFZy","warning":"textColor_warning__0Tt8b","danger":"textColor_danger__FWn-m"};